export const betStatusMap = {
  WON: 'won',
  LOST: 'lost',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  CASHED_OUT: 'cashed_out'
} as const

export type BetStatus = (typeof betStatusMap)[keyof typeof betStatusMap]
